import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import apiInstance from "../../config/api";

function blobUrlToFile(blobUrl, filename) {
    return fetch(blobUrl)
        .then(response => response.blob())
        .then(blob => new File([blob], filename, { type: blob.type }));
}


export const createGroup = createAsyncThunk('group/create', async (data) => {
    try {
        const request = await apiInstance.post("/api/chat/create-group", data);
        const response = request.data;

        if (response.status === 'success') {
            console.log('group created; ', response)
            return response.group
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
});

export const uploadGroupBanner = createAsyncThunk('group/upload-banner', async ({ groupId, image }) => {
    try {
        const formData = new FormData();

        const processedImage = await blobUrlToFile(image, 'new_story.png');
        // console.log('incomin file: ', processedImage)
        formData.append('image', processedImage, processedImage.name)

        const request = await apiInstance.post(`/image/api/group/avatar/${groupId}`, formData);
        const response = request.data;

        if (response.status === 'success') {
            return response.results
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getSuggestedGroups = createAsyncThunk('group/suggested-groups', async () => {
    try {
        const request = await apiInstance.post('/api/chat/groups/SuggestedGroups');
        const response = request.data;

        if (response.status === 'success') {
            return response.groups
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getMyGroups = createAsyncThunk('group/my-groups', async () => {
    try {
        const request = await apiInstance.post("/api/chat/getAdmin/Groups");
        const response = request.data;

        if (response.status === 'success') {
            return response.groups
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getJoinedGroups = createAsyncThunk('group/joined-groups', async () => {
    try {
        const request = await apiInstance.get("/api/chat/groups/user");
        const response = request.data;

        if (response.status === 'success') {
            return response.data
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})


export const getGroupMembers = createAsyncThunk('group/get-members', async (groupId) => {
    try {
        const request = await apiInstance.get(`/api/chat/get-group-members/${groupId}`);
        const response = request.data;

        if (response.status === 'success') {
            return response.members
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const makeUserAdmin = createAsyncThunk('group/add-admin', async ({ groupId, userId }) => {
    try {
        const request = await apiInstance.put(`/api/chat/groups/admin/add/${groupId}/${userId}`);
        const response = request.data;

        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const removeUserAdmin = createAsyncThunk('group/remove-admin', async ({ groupId, userId }) => {
    try {
        const request = await apiInstance.put(`/api/chat/groups/admin/remove/${groupId}/${userId}`);
        const response = request.data;

        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const addGroupMember = createAsyncThunk('group/add-member', async (data) => {
    try {
        const request = await apiInstance.post('/api/chat/add-group-members', data);
        const response = request.data;

        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const removeGroupMember = createAsyncThunk('group/remove-member', async (data) => {
    try {
        const request = await apiInstance.post('/api/chat/remove-group-members', data);
        const response = request.data;

        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const leaveGroup = createAsyncThunk('group/leave', async (groupId) => {
    try {
        const request = await apiInstance.post(`/api/chat/leaveGroup/${groupId}`);
        const response = request.data;

        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const createGroupPost = createAsyncThunk('group/post/create', async ({ caption, files, groupId }, {getState}) => {
    try {
        const state = getState()
        const formData = new FormData()

        if (files && files.length > 0) {
            for (let index = 0; index < files.length; index++) {
                const file = files[index];
                const processedImage = await blobUrlToFile(file, `groupMedia_${index + 1}.png`);
                // console.log('images ', processedImage)

                formData.append('files', processedImage, processedImage.name)
            }

        }
        formData.append('caption', caption)
        const request = await apiInstance.post(`/image/api/group/post/${groupId}`, formData);
        const response = request.data;
        if (response.status === 'success') {
            const { userData:user } = state.user
            const { userId, firstName, lastName, UserName, profilePhoto } = user ?? {}
            const userDetails = { userId, firstName, lastName, UserName, profilePhoto }
            const { postId, postUrl, groupId, postType, caption, createdAt } = response.groupPost
            const postInfo = { postId, postUrl, groupId, postType, caption, createdAt }

            const data = { ...postInfo, user: userDetails }
            return data
        } else {
            toast.error("Post failed to Upload")

            throw new Error(response.message)
        }
    }
    catch (error) {
        toast.error("Post failed to Upload")

        throw new Error(error.message)
    }
})

export const joinPublicGroup = createAsyncThunk('group/group/join', async (groupId) => {
    try {
        const request = await apiInstance.post(`/api/chat/join/group/${groupId}`);
        const response = request.data;
        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})
export const updateGroupInfo = createAsyncThunk('group/update', async ({ data, groupId }) => {
    try {
        const request = await apiInstance.put(`/api/chat/groups/${groupId}`, data);
        const response = request.data;

        if (response.status === 'success') {
            console.log('group updated successfully; ', response)
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})
export const searchGroup = createAsyncThunk('group/search', async (querry) => {
    try {
        const request = await apiInstance.get(`/api/chat/search/group?querry=${querry}`);
        const response = request.data;

        if (response.status === 'success') {
            return response.groups
        }
        else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const pinGroup = createAsyncThunk('group/pin', async (groupId) => {
    try {
        const request = await apiInstance.post(`/api/chat/groups/${groupId}/pin`);
        const response = request.data;
        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const unpinGroup = createAsyncThunk('group/unpin', async (groupId) => {
    try {
        const request = await apiInstance.delete(`/api/chat/groups/${groupId}/pin`);
        const response = request.data;

        console.log('UNpin group response; ', response)
        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})


